<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Portals</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="createDialogSwitch = true">Add</v-btn>
            </v-col>
        </v-row>
        <h3></h3>
        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Url</th>
                        <th>Type</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="portal in portals" v-if="portals.length" class="text-left">
                        <td>{{ portal.name }}</td>
                        <td><a :href="portal.url" class="text-decoration-none text-black" target="_blank">{{
                                portal.url
                            }}</a></td>
                        <td class="text-capitalize">{{ portal.type }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <v-btn :disabled="editDialogSwitch" class="text-warning" prepend-icon="mdi-pencil"
                                       size="x-small" @click="editPortal(portal)">Edit
                                </v-btn>
                                <v-btn class="text-error" prepend-icon="mdi-delete" size="x-small"
                                       @click="deletePortal(portal)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" class="text-center" colspan="4">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else class="text-center" colspan="4">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>
    </v-container>

    <Create-Portal v-if="createDialogSwitch" v-model="createDialogSwitch" @addPortal="addPortal"/>
    <Edit-Portal v-if="editDialogSwitch" v-model="editDialogSwitch" :portal="selectedPortal"
                 @updatePortal="updatePortal"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import EditPortal from "@/components/dialogs/portals/Edit.vue";
import CreatePortal from "@/components/dialogs/portals/Create.vue";

const createDialogSwitch = ref(false);
const {showSnackbar} = useSnackbarStore();
const editDialogSwitch = ref(false);
const selectedPortal = ref(null);
const loading = ref(true);
const portals = ref([]);

onMounted(() => {
    fetchPortals();
});

const fetchPortals = () => {
    send('get', `admin/portals`)
        .then((response) => {
            portals.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Portals could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const addPortal = (portal) => {
    portals.value.unshift(portal);
}
const editPortal = (portal) => {
    selectedPortal.value = portal;
    editDialogSwitch.value = true;
}
const updatePortal = (portal) => {
    portals.value.map((comp, index) => {
        if (comp.id === portal.id) {
            portals.value[index] = portal;
        }
    });
}
const deletePortal = (portal) => {
    if (confirm(`Are you sure to delete "${portal.title}" portal?`)) {
        send('delete', `admin/portals/${portal.id}`)
            .then((response) => {
                if (response.data.success) {
                    portals.value.map((item, index) => {
                        if (item.id === portal.id) {
                            portals.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${portal.title}" Portal could not be deleted`, 'error')
                }
            })
    }
}
</script>
